// extracted by mini-css-extract-plugin
module.exports = {"text-block":"styles_text-block__XkllE","modal-trigger":"styles_modal-trigger__i_piY"};